import { render, staticRenderFns } from "./WavForm.vue?vue&type=template&id=f82012ca&scoped=true&"
import script from "./WavForm.vue?vue&type=script&lang=js&"
export * from "./WavForm.vue?vue&type=script&lang=js&"
import style0 from "./WavForm.vue?vue&type=style&index=0&id=f82012ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82012ca",
  null
  
)

export default component.exports